<div class="overview-area ptb-75">
    <div class="container">
        <div 
            class="overview-content"
        >
            <h3>Ne manquez aucune de nos actualités</h3>
            <p class="text-black">Vous êtes passionné(e)s par la technologie africaine ? Suivez-nous pour rester à l'affût à travers nos articles d'actualités, nos vidéos d'analyses et d'interviews.</p>
            <a href="https://youtube.com/channel/UC60eYhuHatzPs-qTtyudIFg?sub_confirmation=1" target="_blank" class="default-btn"><i class="ri-youtube-fill"></i> Chaine Youtube</a>
            <ul class="overview-info-list">
                <li>
                    <span class="color-text">
                        Suivre sur :
                    </span>
                </li>
                <li class="list">
                    <a href="https://www.instagram.com/afrotech_hub" target="_blank">
                        <i class="flaticon-instagram"></i> 
                        Instagram
                    </a>
                </li>
                <li class="list">
                    <a href="https://www.linkedin.com/company/afrotechhub/" target="_blank">
                        <i class="ri-linkedin-fill exception-icon"></i> 
                        Linkedin
                    </a>
                </li>
                <li class="list">
                    <a href="https://www.facebook.com/afrotechub/" target="_blank">
                        <i class="flaticon-facebook"></i> 
                        Facebook
                    </a>
                </li>
                <li class="list">
                    <a href="https://x.com/afrotech_hub" target="_blank">
                        <i class="flaticon-twitter"></i> 
                        X
                    </a>
                </li>
                <li class="list">
                    <a href="https://open.spotify.com/show/2ASTbhkADWhD2w0eDPWtkI?si=4c6c29047e8149ed" target="_blank">
                        <i class="flaticon-spotify"></i> 
                        Spotify
                    </a>
                </li>
            </ul>
        </div>
    </div>
</div>